import { render, staticRenderFns } from "./NbaDailyLineups.vue?vue&type=template&id=00afbf21&scoped=true"
import script from "./NbaDailyLineups.vue?vue&type=script&lang=js"
export * from "./NbaDailyLineups.vue?vue&type=script&lang=js"
import style0 from "./NbaDailyLineups.vue?vue&type=style&index=0&id=00afbf21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00afbf21",
  null
  
)

export default component.exports